module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || "jgj81odt",
    dataset: process.env.GATSBY_SANITY_DATASET || "production"
  }
};
